"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Command as CommandPrimitive } from "cmdk";
// import { Search } from "lucide-react"
import { cn } from "../utils";
import { Dialog, DialogContent } from "./Dialog";
import { SIcon } from "../../components";
const Command = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(CommandPrimitive, _object_spread({
        ref: ref,
        className: cn("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", className)
    }, props));
});
Command.displayName = CommandPrimitive.displayName;
const CommandDialog = (_param)=>{
    var { children } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Dialog, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx(DialogContent, {
            className: "overflow-hidden p-0 shadow-lg",
            children: /*#__PURE__*/ _jsx(Command, {
                className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                children: children
            })
        })
    }));
};
const CommandInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center border-b border-white/10 px-4",
        "cmdk-input-wrapper": "",
        children: [
            /*#__PURE__*/ _jsx(SIcon, {
                type: "search",
                className: "h-3.5 w-3.5 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ _jsx(CommandPrimitive.Input, _object_spread({
                ref: ref,
                className: cn("flex h-11 w-full focus:!outline-none focus:!border-transparent rounded-md bg-transparent py-3 text-sm outline-none border-none  disabled:cursor-not-allowed disabled:opacity-50", className)
            }, props))
        ]
    });
});
CommandInput.displayName = CommandPrimitive.Input.displayName;
const CommandList = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(CommandPrimitive.List, _object_spread({
        ref: ref,
        className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className)
    }, props));
});
CommandList.displayName = CommandPrimitive.List.displayName;
const CommandEmpty = /*#__PURE__*/ React.forwardRef((props, ref)=>/*#__PURE__*/ _jsx(CommandPrimitive.Empty, _object_spread({
        ref: ref,
        className: "py-6 text-center text-white/50 text-sm"
    }, props)));
CommandEmpty.displayName = CommandPrimitive.Empty.displayName;
const CommandGroup = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(CommandPrimitive.Group, _object_spread({
        ref: ref,
        className: cn("overflow-hidden p-1 text-white [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-white/50", className)
    }, props));
});
CommandGroup.displayName = CommandPrimitive.Group.displayName;
const CommandSeparator = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(CommandPrimitive.Separator, _object_spread({
        ref: ref,
        className: cn("-mx-1 h-px bg-white/10", className)
    }, props));
});
CommandSeparator.displayName = CommandPrimitive.Separator.displayName;
const CommandItem = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(CommandPrimitive.Item, _object_spread({
        ref: ref,
        className: cn("relative text-white/[0.80] hover:bg-white/10 hover:text-white flex cursor-pointer gap-2 select-none items-center px-2 py-1.5 text-sm outline-none data-[disabled='true']:pointer-events-none rounded-md data-[selected='true']:bg-white/10 data-[selected='true']:text-white data-[disabled='true']:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-3.5 [&_svg]:shrink-0", className)
    }, props));
});
CommandItem.displayName = CommandPrimitive.Item.displayName;
const CommandShortcut = (_param)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("span", _object_spread({
        className: cn("ml-auto text-xs tracking-widest text-white/50", className)
    }, props));
};
CommandShortcut.displayName = "CommandShortcut";
export { Command, CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem, CommandShortcut, CommandSeparator,  };
